import { FC } from 'react';

import { EnquiryType } from '@shared/api/enquiry/enquiry.interface';
import { EnquiryPanel } from '@shared/containers/EnquiryForm/EnquiryPanel';

import { useSellerTopNavHook } from '../hooks/useSellerTopNavHook';

/**
 * 화환 판매자 콘솔의 1:1 문의 — 관리자 문의사항 관리의 "셀러" 탭으로 들어간다.
 * 상단 네비가 제목을 대신하므로 패널의 큰 제목은 숨긴다. 접수 후엔 내 문의내역 탭으로 넘어간다.
 */
const SellerEnquiryPage: FC = function SellerEnquiryPage() {
  useSellerTopNavHook('문의하기');

  return (
    <div className="mx-auto w-full max-w-xl">
      <EnquiryPanel type={EnquiryType.Seller} showTitle={false} className="p-4 pt-6" />
    </div>
  );
};

export default SellerEnquiryPage;
